export default "__VITE_ASSET__Dw$KWMDt__"